import React, { useState, useMemo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { ErrorType } from '../../../../../../../domain/entities/Auth';
import { CreateUserQuery } from '../../../../../../../hooks/api/auth';
import TextInput, { TextInputType } from '../../../../../../../atoms/TextInput';
import LabeledContainer from '../../../../../../../molecules/common/LabeledContainer';
import PurchaseCreateUserConfirmAlert from '../PurchaseCreateUserConfirmAlert';
import ErrorMessage from '../CreateUserErrorMessage';
import { SubmitButton } from '../../../../../../../atoms/SubmitButton';

interface Props {
  postable: boolean;
  onSubmit: (query: CreateUserQuery) => void;
  errors?: ErrorType[];
}

const InputCreateUser: React.FC<Props> = (props) => {
  const intl = useIntl();

  const [lastName, setLastName] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const submittable = useMemo(() => {
    return !!lastName && !!firstName && !!email && !!password;
  }, [lastName, firstName, email, password]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      currentTarget: { name, value },
    } = e;
    switch (name) {
      case 'lastName':
        setLastName(value);
        break;
      case 'firstName':
        setFirstName(value);
        break;
      case 'email':
        setEmail(value);
        break;
      case 'password':
        setPassword(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = useCallback(async () => {
    props.onSubmit({ lastName, firstName, email, password });
  }, [props, lastName, firstName, email, password]);

  return (
    <div>
      <LabeledContainer
        label={intl.formatMessage({
          id: 'purchases.inputCreateUser.lastName',
        })}
        paddingTop={true}
      >
        <TextInput
          type={TextInputType.Text}
          name={'lastName'}
          value={lastName}
          onChange={handleChange}
        />
      </LabeledContainer>
      <LabeledContainer
        label={intl.formatMessage({
          id: 'purchases.inputCreateUser.firstName',
        })}
        paddingTop={true}
      >
        <TextInput
          type={TextInputType.Text}
          name={'firstName'}
          value={firstName}
          onChange={handleChange}
        />
      </LabeledContainer>
      <LabeledContainer
        label={intl.formatMessage({
          id: 'purchases.inputCreateUser.email',
        })}
        paddingTop={true}
      >
        <TextInput
          type={TextInputType.Email}
          name={'email'}
          value={email}
          onChange={handleChange}
        />
      </LabeledContainer>
      <LabeledContainer
        label={intl.formatMessage({
          id: 'purchases.inputCreateUser.password',
        })}
      >
        <TextInput
          type={TextInputType.Password}
          name={'password'}
          value={password}
          onChange={handleChange}
          placeholder={intl.formatMessage({
            id: 'purchases.inputCreateUser.passwordPlaceholder',
          })}
        />
      </LabeledContainer>
      <ErrorMessage errors={props.errors} />
      <PurchaseCreateUserConfirmAlert />
      <SubmitButton
        type="button"
        onClick={handleSubmit}
        value={intl.formatMessage({
          id: 'purchases.inputCreateUser.submitButton',
        })}
        disabled={!submittable || !props.postable}
        postable={props.postable}
      >
        {intl.formatMessage({ id: 'purchases.inputCreateUser.submitButton' })}
      </SubmitButton>
    </div>
  );
};

export default InputCreateUser;
